import React from 'react';

import {
  DeleteMessage,
  ModalButtonWrapper,
  ModalWrapper,
  OutlineButton,
} from '../../../services/settings/appStyle/global.style';
import Modal from '../modal';
import Button from '../button';
import { IntlMessages } from '../../../helper/langHelper';
import ChildModal from '../modal/childModal';
import { ErrorSvg } from '../../icons';

const DeleteConfirmationModal = ({
  onClose,
  title = <IntlMessages id="text.delete.confirmation" />,
  onConfirm,
  message = '',
  buttonDeleteText = <IntlMessages id="modal.button.delete" />,
  isLoading = false,
}) => {
  return (
    <>
      <Modal isOpen={true} onClose={isLoading ? undefined : onClose} title={title}>
        <ModalWrapper>
          <DeleteMessage>{message}</DeleteMessage>
          <ModalButtonWrapper>
            <OutlineButton onClick={onClose} disabled={isLoading}>
              <IntlMessages id="modal.button.close" />
            </OutlineButton>
            {onConfirm && (
              <Button varient="normal" onClick={onConfirm} disabled={isLoading}>
                {isLoading ? (
                  <IntlMessages id="modal.button.deleting" defaultMessage="Deleting..." />
                ) : (
                  buttonDeleteText
                )}
              </Button>
            )}
          </ModalButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default DeleteConfirmationModal;

export const ChildDeleteConfirmationModal = ({
  onClose,
  title = <IntlMessages id="text.delete.confirmation" />,
  onConfirm,
  message = '',
  buttonDeleteText = <IntlMessages id="modal.button.delete" />,
  isConfirmDisabled = false,
}) => {
  return (
    <>
      <ChildModal isOpen={true} onClose={onClose} title={title}>
        <ModalWrapper>
          <DeleteMessage>{message}</DeleteMessage>
          <ModalButtonWrapper>
            <OutlineButton onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </OutlineButton>
            <Button varient="normal" onClick={onConfirm} disabled={isConfirmDisabled}>
              {buttonDeleteText}
            </Button>
          </ModalButtonWrapper>
        </ModalWrapper>
      </ChildModal>
    </>
  );
};

export const DeleteErrorModal = ({ onClose, title = 'Error', errorMessage }) => {
  return (
    <>
      <ChildModal isOpen={true} onClose={onClose} title={title} color="warning">
        <ModalWrapper>
          <ErrorSvg style={{ width: '60px', height: '60px', justifySelf: 'center' }} />
          <DeleteMessage style={{ textAlign: 'center' }}>{errorMessage}</DeleteMessage>
          <ModalButtonWrapper>
            <OutlineButton onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </OutlineButton>
          </ModalButtonWrapper>
        </ModalWrapper>
      </ChildModal>
    </>
  );
};

export const WarningModal = ({
  onClose,
  title = <IntlMessages id="text.delete.confirmation" />,
  message = '',
}) => {
  return (
    <>
      <Modal isOpen={true} onClose={onClose} title={title}>
        <ModalWrapper>
          <DeleteMessage>{message}</DeleteMessage>
          <ModalButtonWrapper>
            <OutlineButton onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </OutlineButton>
          </ModalButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};
